<div class="page-layout simple fullwidth" fusePerfectScrollbar *ngIf="translations">
    <!-- CONTENT -->
    <div class="content p-16 mat-white-bg">
        <mat-card>

            <form  [formGroup]="formGroup" novalidate>
                <div class="section-header">{{translations.lblReport}}</div>
                <div fxLayout="row" fxLayoutAlign="start start">

                    <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="25">
                        <input matInput [matDatepicker]="dp3" formControlName="ShipDate"
                               required placeholder="{{translations.lblShipDate}}" 
                               readonly [(ngModel)]="shipdate.ShipDate">
                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                        <mat-error *ngIf="formGroupErrors.ShipDate.required">
                            {{translations.msgSelectShipDate}}
                        </mat-error>

                    </mat-form-field>
                    <button mat-raised-button color="accent" class="mr-24" fxFlex.xs="100" 
                     [disabled]="invalidForm"
                            (click)="generate();" style="line-height: 45px;">
                        {{translations.lblGenerate}}
                    </button>
                </div>
                <!-- <object 
                fxLayout="row" fxLayoutAlign="start start"
                data="{{getPDFUrl()}}" type="application/pdf" width="100%" height="100%">
 
                </object> -->
                
            </form>
        </mat-card>
    </div>
    <!-- / CONTENT -->

</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/billofloading/billofloading.component.html